export default __webpack_public_path__ + "static/media/carSelected.fd81bedc.svg";